export { default } from './FeatureBadgeSlot'
export type { FeatureBadgeSlotProps } from './FeatureBadgeSlot'
